import React from "react";
import {
  US,
  EU,
  GB,
  JP,
  AU,
  CA,
  CH,
  CN,
  IN,
  BR,
  RU,
  KR,
  MX,
  SG,
  HK,
  NZ,
  SE,
  NO,
  DK,
  PL,
  TR,
  ZA,
  AE,
  SA,
  EG,
  IL,
  TH,
  MY,
  ID,
  PH,
  VN,
  LB,
} from "country-flag-icons/react/3x2";

const FLAG_BY_CODE = {
  US,
  EU,
  GB,
  JP,
  AU,
  CA,
  CH,
  CN,
  IN,
  BR,
  RU,
  KR,
  MX,
  SG,
  HK,
  NZ,
  SE,
  NO,
  DK,
  PL,
  TR,
  ZA,
  AE,
  SA,
  EG,
  IL,
  TH,
  MY,
  ID,
  PH,
  VN,
  LB,
};

/**
 * Small inline flag for wallet/currency dropdowns (USD → US, EUR → EU, etc.).
 * Uses bundled SVGs from country-flag-icons (only flags we map in currencyFlagHelper).
 */
export default function WalletCurrencyFlag({ countryCode, title, style = {} }) {
  if (!countryCode || typeof countryCode !== "string") return null;
  const key = countryCode.trim().toUpperCase();
  const Cmp = FLAG_BY_CODE[key];
  if (!Cmp || typeof Cmp !== "function") return null;
  return (
    <Cmp
      title={title || key}
      aria-hidden
      style={{
        width: 22,
        height: "auto",
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
        borderRadius: 2,
        ...style,
      }}
    />
  );
}
